import { canAccessModule, readStoredLicenseSnapshot } from "./licenseHelpers.mjs";
import { expandRoleAliases, normalizeRoleKey } from "./roleHelpers.mjs";

const normalizePlacementId = (value) => {
  const normalized = Number(value || 0);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
};

export const companyOverviewAccessMethods = {
  readStoredRoleKeys() {
    if (typeof window === "undefined" || !window.localStorage) return [];
    const roleKeys = [];
    const pushRole = (value) => {
      const normalized = normalizeRoleKey(value);
      if (normalized) roleKeys.push(normalized);
    };

    pushRole(window.localStorage.getItem("user-role"));
    pushRole(window.localStorage.getItem("user-primary-role"));

    try {
      const rawRoles = JSON.parse(window.localStorage.getItem("user-roles") || "[]");
      if (Array.isArray(rawRoles)) {
        rawRoles.forEach((entry) => {
          if (typeof entry === "string") {
            pushRole(entry);
          } else {
            pushRole(entry?.key || entry?.role || entry?.name);
          }
        });
      }
    } catch (_) {
      return [...new Set(roleKeys)];
    }

    return [...new Set(roleKeys)];
  },
  buildRoleAliasSet(roleKeys = []) {
    const roleSet = new Set();
    (Array.isArray(roleKeys) ? roleKeys : []).forEach((roleKey) => {
      const normalized = normalizeRoleKey(roleKey);
      if (!normalized) return;
      roleSet.add(normalized);
      expandRoleAliases(normalized).forEach((alias) => roleSet.add(alias));
    });
    return roleSet;
  },
  canAccessOverviewFeature(sourceType) {
    const normalizedSourceType = String(sourceType || "").trim().toLowerCase();
    if (normalizedSourceType !== "contract" && normalizedSourceType !== "onboarding") {
      return true;
    }
    const roleSet = this.buildRoleAliasSet(this.readStoredRoleKeys());
    const hasAllowedRole =
      roleSet.has("admin") ||
      roleSet.has("miniadmin") ||
      roleSet.has("crm-admin") ||
      roleSet.has("crm-operator");
    if (!hasAllowedRole) return false;
    return canAccessModule("crm", {
      roleKeys: Array.from(roleSet),
      licenseSnapshot: readStoredLicenseSnapshot(),
      fallbackIfUnknown: true,
    });
  },
  resolveOverviewRoute(item) {
    const sourceType = String(item?.sourceType || "").trim().toLowerCase();
    if (!this.canAccessOverviewFeature(sourceType)) return null;
    if (sourceType === "lead") {
      if (normalizePlacementId(item?.placementId)) {
        return { name: "NcrmLeadDetails", params: { id: String(Number(item.placementId)) } };
      }
      if (normalizePlacementId(item?.boardId)) {
        return { name: "NcrmLeadBoard", params: { id: String(Number(item.boardId)) } };
      }
      return null;
    }
    if (sourceType === "deal") {
      if (normalizePlacementId(item?.placementId)) {
        return { name: "NcrmDealDetails", params: { id: String(Number(item.placementId)) } };
      }
      if (normalizePlacementId(item?.boardId)) {
        return { name: "NcrmDealBoard", params: { id: String(Number(item.boardId)) } };
      }
      return null;
    }
    if (sourceType === "contract") {
      if (normalizePlacementId(item?.placementId)) {
        return { name: "NcrmContractDetails", params: { contractId: String(Number(item.placementId)) } };
      }
      return null;
    }
    if (sourceType === "onboarding") {
      if (normalizePlacementId(item?.placementId)) {
        return { name: "NcrmOnboardingDetails", params: { onboardingId: String(Number(item.placementId)) } };
      }
      if (normalizePlacementId(item?.boardId)) {
        return { name: "NcrmOnboardingBoard", params: { productId: String(Number(item.boardId)) } };
      }
    }
    return null;
  },
};
